import { render, staticRenderFns } from "./CategoryFeatures.vue?vue&type=template&id=2788717e"
import script from "./CategoryFeatures.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryFeatures.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports